import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const ExamSidebarItem = ({ text, required }) => {
    return (_jsxs(_Fragment, { children: [`${text}`, " \u00A0", required ? _jsx("b", Object.assign({ className: "text-danger" }, { children: "*" }), void 0) : null] }, void 0));
};
export default ExamSidebarItem;
